import type { ListBuilderList } from '../../../types';

/**
 * Not Usable at State (PD-16225) — the licences a customer cannot legally use
 * today, whatever word the board used.
 *
 * Chris, 2026-09-17: "a board action may have forced a cancelation or early
 * expiration … if they are showing they either need to be replaced or [you]
 * have to stop selling to that client." So this list is WIDER than the Adverse
 * Action list beside it: board actions (Suspended / Revoked / Surrendered /
 * Denied) AND administratively dead licences (Cancelled / Expired / Inactive /
 * Retired / Deceased). Pending and Unknown are excluded — neither asserts the
 * licence is dead.
 *
 * It also counts an UNCONFIRMED licence-number suggestion at 90%+ confidence,
 * not only a confirmed link, because Tier-1 auto-confirm deliberately refuses
 * to link onto a dead registry row: on 2026-09-17 all 105 of republic's risky
 * licences sat unconfirmed, so the confirmed-only Adverse Action card read
 * None. The same `licenseRegistryStanding: unusable` filter backs both this
 * list and the dashboard card, so the click-through count matches.
 *
 * Default sort is `recent-sale-desc` — the actively-buying client holding a
 * dead licence is the one to call first.
 */
export const notUsableList: ListBuilderList = {
	id: 'default-licenses-not-usable',
	cacheTTL: 300000,
	// PD-16230: the tab must read the same as the dashboard card it backs.
	name: 'Dead License',
	type: 'default',
	// PD-16252: superseded by Needs Attention → Dead License, which has its own
	// columns and actions. Inactive (no tab) but still openable by URL so saved
	// links keep working.
	active: false,
	// Sits with the other risk tabs (Adverse Action is 5).
	sortOrder: 6,
	filterRules: {
		// The dashboard card counts ACTIVE BUYERS only, and its Review link lands
		// here: without this the card read 17 accounts while the list opened on
		// 1,716 rows (republic prod, 2026-09-18). Visible, so the scope is stated.
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseRegistryStanding: {
			defaultValue: [
				{
					id: 'unusable',
					label: 'Dead License',
				},
			],
			locked: true,
			hidden: true,
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
